import axiosInstance from "../api/axios";

// Platform-wide dashboard for the Zumalestate admin (ZUMALE_USER).
export const fetchZumaleAdminDashboard = async () => {
  return axiosInstance.get("/dashboard/zumale-admin");
};

// Per-developer dashboard (developer admin / staff).
export const fetchDeveloperAdminDashboard = async (projectId = null) => {
  const params = projectId ? { projectId } : {};
  return axiosInstance.get("/dashboard/developer-admin", { params });
};
